import { connect } from 'react-redux';
import StabSearchBox from './StabSearchBox';

const mapStateToProps = ({ system: { legacy: { stabSearchBoxMarkup }}}) => ({
  markup: stabSearchBoxMarkup
});

export default connect(mapStateToProps)(StabSearchBox);

